module.exports = __webpack_public_path__ + "static/media/md-barcode.8973283e.svg";